import React from "react";
import ProSectionHeader from "../common/ProSectionHeader";
import ProDropDown from "../common/ProDropDown";
import { useHierarchyService } from "../../hooks/useHierarchyService";
import useCensus from "../../hooks/useCensus";

const ProCensusMoveClientForm = ({formik, onChanged})=>{
    const {data:{selectedLocations}} = useCensus({ refreshTree: false });  
    const {data :{buildings, parentTypes, parents, rooms, beds}} = useHierarchyService();      
    return <div>
        <ProSectionHeader headerText = "Move To"/>
        <ProDropDown                       
            id="location"
            value={formik.values.location}
            style={{ width: "100%", marginBottom: "2px" }}
            onChange={onChanged}
            options={selectedLocations}
            optionLabel="name"
            placeholder="Location"
            formik={formik}
            error="location"
            required
        />
         <ProDropDown
            id="building"
            value={formik.values.building}
            style={{ width: "100%", marginBottom: "2px" }}
            onChange={onChanged}
            options={buildings}
            optionLabel="name"
            placeholder="Building"
            formik={formik}
            error="building"   
            required                     
        />
         <ProDropDown
            id="parentType"
            value={formik.values.parentType}
            style={{ width: "100%", marginBottom: "2px" }}
            onChange={onChanged}
            options={parentTypes}
            optionLabel="name"
            placeholder="Level"
            formik={formik}
            error="parentType"
            required
        /> 
         { (parents && parents.length > 0) && <ProDropDown
            id="parent"
            value={formik.values.parent}
            style={{ width: "100%", marginBottom: "2px" }}
            onChange={onChanged}
            options={parents}
            optionLabel="name"
            placeholder={formik.values.parentType.name}
            formik={formik}
            error="parent"
            required
        /> } 
        <ProDropDown
            id="room"
            value={formik.values.room}
            style={{ width: "100%", marginBottom: "2px" }}
            onChange={onChanged}
            options={rooms}
            optionLabel="name"
            placeholder="Room"
            formik={formik}
            error="room"
            required
        />   
         <ProDropDown
            id="bed"
            value={formik.values.bed}
            style={{ width: "100%", marginBottom: "2px" }}
            onChange={onChanged}
            options={beds}
            optionLabel="name"
            placeholder="Bed"
            formik={formik}
            error="bed"
            required
        />             
    </div>

}

export default ProCensusMoveClientForm;